import {useEffect, useState} from "react";
import {UserDto, UserRoleType} from "../../client/user/User";
import {CommonTranslKey} from "../../common/CommonTranslKey";
import {useClientLocator} from "../../client/ApiClientLocator";
import {useTranslation} from "react-i18next";
import UserContext from "./UserContext";

export interface UserProviderProps {
    children?: React.ReactNode;
}

export default function UserProvider(props: Readonly<UserProviderProps>) {
    const {children} = props;

    const {userClient} = useClientLocator();
    const {t} = useTranslation();

    const [user, setUser] = useState<UserDto>();
    const [roles, setRoles] = useState<UserRoleType[]>([]);

    useEffect(() => {
        userClient.findMe()
            .then((userDto) => {
                setUser(userDto);
                return userClient.findMyValidRoles();
            })
            .then((roles) => {
                setRoles(roles);
            })
            .catch((error) => console.error(t(CommonTranslKey.UNEXPECTED_ERROR), error))
    }, [t, userClient]);

    return (
        <UserContext.Provider value={{user: user, validRoles: roles}}>
            {children}
        </UserContext.Provider>
    );
}